import React from 'react';
import { compose } from 'ramda';
import styleFile from './NoAvail.js';
import SearchOptions from '../../components/functional/SearchOptions';
import { AvailAlert } from '../../components/functional/AvailAlert';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { connect } from 'react-redux';
import Footer from '../../components/functional/Footer/Footer';
import { Loading } from '@synergycms_core/components/functional/Loading';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';

const NoAvail = class NoAvail extends React.Component {
  static displayName = 'NoAvail';

  constructor(props) {
    super(props);
    this.state = {
      params: this.props.params,
    };
  }
  
  render() {
    const {
      current_step,
      theme,
    } = this.props;

    const { classes } = theme.styles;

    return (
      <div className={classes.defaultStyle}>
        {current_step.get('type') === 'mono' ? <SearchOptions innerStyle={['monoHotelSearchOptions']}/> : null}
        <div>
          <AvailAlert type={"invalid_date"} objVars={{}} showRelated={false}/>
        </div>
        <div className={classes.footer}>
          <Footer />
        </div>
      </div>
    );
  }
};

const fragment = props => {

  const engineSygyData = window.frontLoader || window.engine_sygy_data;
  const { webType } = props;
  const group = engineSygyData && engineSygyData.group;
  const corporateLogin = window.LoginUser && +window.LoginUser.tipo_perfil === 1 ? window.LoginUser : null;
  const loyaltyLogin = window.LoginUser && +window.LoginUser.tipo_perfil === 2 ? window.LoginUser : null;
  const userLogIn = (corporateLogin && corporateLogin.usuario !== 'NoLogin') || (loyaltyLogin && loyaltyLogin.usuario !== 'NoLogin');

  return (
  <React.Fragment>
    <Loading
      richText={{
        ucFirst: true,
        innerStyle: ['descriptionText'],
        text: '_%estamos buscando los mejores precios para ti%_',
        translate: true
      }}
        showLoyaltyBanner={webType === 'PORTAL' && group === 'eurostarshotels' && !userLogIn}
    />
  </React.Fragment>
);
};

const mapStateToProps = (store) => {
  const hotelId = store.getIn(['customer', 'current_hotel']);

  let resolveAvail;
  let hotelInfo;
  if(store.getIn(['customer', 'step', 'current_step', 'type']) === 'mono') {
    resolveAvail = store.getIn(['customer', 'params', store.getIn(["availQuery", "mono","query_params"])]) ===
      store.getIn(['hotels', hotelId, 'params', store.getIn(["availQuery", "mono","base_query_params"])])
      ? true
      : undefined;
    hotelInfo = store.getIn(['hotels', hotelId, 'success']);
  } else {
    resolveAvail = true;
    hotelInfo = true;
  }

  
  return {
    hotelInfo,
    resolveAvail,
    current_step: store.getIn(['customer', 'step', 'current_step'], undefined),
  }
};

export default compose(
  validateAsyncComponent(mapStateToProps, [], fragment),
  connect(mapStateToProps),
  withThemeJSS({ styleFile, index: 100 }),
)(NoAvail);
